export const filmContent = {
    fr: {
        eyebrow: 'FILMS & SÉRIES',
        title: 'Diffusion illimitée des derniers films, séries et variantes de chaînes en direct.',
        filmsLabel: 'Films',
        seriesLabel: 'Séries',
    },
    es: {
        eyebrow: 'PELÍCULAS Y SERIES',
        title: 'Streaming ilimitado de las últimas películas, series y canales en directo.',
        filmsLabel: 'Películas',
        seriesLabel: 'Series',
    },
};
